import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { ToastyService, ToastyConfig, ToastOptions, ToastData } from 'ng2-toasty';
import { ModalDismissReasons, NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { AppModalComponent } from "../components/app-modal/app-modal.component";
import { HttpClient } from '@angular/common/http';
import swal from 'sweetalert2';

@Injectable()
export class FrontEndService {
    required_delivery_date: any;
    required_interim_date: any;
    full_screen = false;
    en_json_data: any;
    selectedLang: any;
    isOnline = false;
    isOpen = false;
    public modalRef: NgbModalRef;
    closeResult: string;

    show_header = true;

    /**
     * Method to show alert modal
     * @param header
     * @param message
     * @param isTranslated
     */
    public showAlert(header, message, isTranslated = false) {
        // this.modal.header = header;
        // this.modal.message = message;
        this.openModal(header, message, isTranslated);
    }

    /**
     * Open modal
     * @param header
     * @param message
     * @param isTranslated
     */
    openModal(header, message, isTranslated) {
        if (isTranslated) {
            header = this.en_json_data[header];
            message = this.en_json_data[message];
        }
        if (this.isOpen) {
            // this.modalRef.close();
            this.modalRef.componentInstance.header = header;
            this.modalRef.componentInstance.message = message;
        } else {
            this.modalRef = this.modalService.open(AppModalComponent);
            this.modalRef.componentInstance.header = header;
            this.modalRef.componentInstance.message = message;
            this.isOpen = true;
            this.modalRef.result.then((result) => {
                this.closeResult = `Closed with: ${result}`;
                this.isOpen = false;
            }, (reason) => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
                this.isOpen = false;
            });
        }
    }

    /**
     * Get dismiss reason for modal
     * @param reason
     * @returns {string}
     */
    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    /**
     * Add a toast on the screen
     * @param title
     * @param message
     * @param type
     */
    public addToast(title, message, type) {
        // Just add default Toast with title only
        // this.toastyService.default('Hi there');
        // Or create the instance of ToastOptions
        const toastOptions: ToastOptions = {
            title: this.en_json_data[title],
            msg: this.en_json_data[message] ? this.en_json_data[message] : message,
            showClose: true,
            timeout: 5000,
            theme: 'bootstrap',
            onAdd: (toast: ToastData) => {

            },
            onRemove: (toast: ToastData) => {

            }
        };

        switch (type) {
            case 'default': this.toastyService.default(toastOptions); break;
            case 'info': this.toastyService.info(toastOptions); break;
            case 'success': this.toastyService.success(toastOptions); break;
            case 'wait': this.toastyService.wait(toastOptions); break;
            case 'error': this.toastyService.error(toastOptions); break;
            case 'warning': this.toastyService.warning(toastOptions); break;
        }
    }
    constructor(
        private _location: Location,
        private toastyService: ToastyService,
        private toastyConfig: ToastyConfig,
        private http: HttpClient,
        private modalService: NgbModal,
    ) {
        // Assign the selected theme name to the `theme` property of the instance of ToastyConfig.
        // Possible values: default, bootstrap, material
        this.toastyConfig.theme = 'bootstrap';
    }

    /**
     * Go to previous state
     */
    back() {
        this._location.back();
    }

    /**
     * Expand project wall to full screen
     */
    expand() {
        this.full_screen = !this.full_screen
    }

    toggleOnlineStatus() {
        // Added timeout as ng model does not work on checkbox without timeout
        setTimeout(() => {
            localStorage.setItem('onlineStatus', this.isOnline.toString());
        }, 200);

    }

    timeAgoConversion(previous) {

        if (previous != null) {
            const date = new Date(previous);
            const previousTime = date.getTime();
            const currentTime = Date.now();
            const msPerMinute = 60 * 1000;
            const msPerHour = msPerMinute * 60;
            const msPerDay = msPerHour * 24;
            const msPerMonth = msPerDay * 30;
            const msPerYear = msPerDay * 365;

            const elapsed = currentTime - previousTime;
            let timeAgo = '';
            const translateJson = this.en_json_data;

            if (elapsed < msPerMinute) {
                timeAgo = Math.round(elapsed / 1000) + translateJson.seconds_ago;
            } else if (elapsed < msPerHour) {
                timeAgo = Math.round(elapsed / msPerMinute) + translateJson.minutes_ago;
            } else if (elapsed < msPerDay) {
                timeAgo = Math.round(elapsed / msPerHour) + translateJson.hours_ago;
            } else if (elapsed < msPerMonth) {
                timeAgo = Math.round(elapsed / msPerDay) + translateJson.days_ago;
            } else if (elapsed < msPerYear) {
                timeAgo = Math.round(elapsed / msPerMonth) + translateJson.months_ago;
            } else {
                timeAgo = Math.round(elapsed / msPerYear) + translateJson.years_ago;
            }

            return timeAgo;
        }
        return this.en_json_data.n_a;
    }

    isSameAnswer(el, index, arr) {
        // Do not test the first array element, as you have nothing to compare to
        if (index === 0) {
            return true;
        } else {
            // do each array element value match the value of the previous array element
            return (el.notification_blocked === arr[index - 1].notification_blocked);
        }
    }

    getTranslateJsonFile(lang, callBack) {
        this.http.get('../../assets/translations/' + lang + '.json')
            .subscribe(response => {
                this.en_json_data = response;
                callBack();
            });
    }

    gotoTop(el) {
        const elmnt = document.querySelector(el);
        elmnt.scrollTop = 0;
    }

    topScroll(event, el) {
        const elmnt = document.querySelector(el);
        if(elmnt.scrollTop > 150) {
            document.querySelector(el + ' .go-top').classList.remove('d-none');
        } else {
            document.querySelector(el + ' .go-top').classList.add('d-none');
        }
    }

    confirmAlert(swalTitle, swalText, swalType, callback) {
        swal({
            title: this.en_json_data[swalTitle],
            html: this.en_json_data[swalText],
            type: this.en_json_data[swalType],
            showCancelButton: true,
            confirmButtonText: this.en_json_data['yes'],
            cancelButtonText: this.en_json_data['no']
        }).then((result) => {
            callback(result);
        });
    }

    customAlert(swalTitle, swalText, swalType, confirmButtonText, cancelButtonText, callback) {
        swal({
            title: this.en_json_data[swalTitle],
            html: this.en_json_data[swalText],
            type: this.en_json_data[swalType],
            showCancelButton: true,
            confirmButtonText: this.en_json_data[confirmButtonText],
            cancelButtonText: this.en_json_data[cancelButtonText]
        }).then((result) => {
            callback(result);
        });
    }

    /**
     * Converts image from url to base64 image and returns it as a string
     * @param url
     * @param callback
     */
    convertImageUrlToBase64(url, callback) {
        const xhr = new XMLHttpRequest();
        xhr.onload = function() {
            const reader = new FileReader();
            reader.onloadend = function() {
                callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    }
}
